"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStoreAccount = void 0;
exports.fetchUserContext = fetchUserContext;
exports.getPartnerAccount = getPartnerAccount;
exports.identifyGuestUser = identifyGuestUser;
exports.identifyUser = identifyUser;
exports.identifyUserSailthru = identifyUserSailthru;
exports.invitePartner = invitePartner;
exports.receiveIdentifyGuestUser = receiveIdentifyGuestUser;
exports.receiveIdentifyUser = receiveIdentifyUser;
exports.receivePartnerStatus = receivePartnerStatus;
exports.receiveUser = receiveUser;
exports.removeOrRevokePartner = void 0;
exports.requestPartnerStatus = requestPartnerStatus;
exports.requestUser = requestUser;
exports.updateUserStatus = updateUserStatus;
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.promise.js");
var _storage = require("../../util/storage");
var ActionType = _interopRequireWildcard(require("./userActionTypes"));
var _api = _interopRequireDefault(require("../../http/api"));
var _trackingHelper = require("../../tracking/trackingHelper");
var _detectBrowser = require("../../util/detectBrowser");
var _logRocketUtils = require("../../util/logrocket/logRocketUtils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function requestUser() {
  return {
    type: ActionType.REQUEST_USER
  };
}
function receiveUser(response) {
  return {
    type: ActionType.RECEIVE_USER,
    payload: response
  };
}
function receiveIdentifyUser() {
  return {
    type: ActionType.IDENTIFY_USER
  };
}
function receiveIdentifyGuestUser() {
  return {
    type: ActionType.IDENTIFY_GUEST_USER
  };
}
function identifyUser(_ref) {
  var userContext = _ref.userContext,
    hasIdentified = _ref.hasIdentified,
    forceIdentify = _ref.forceIdentify;
  if (!(userContext !== null && userContext !== void 0 && userContext.is_guest) && (!hasIdentified || forceIdentify)) {
    var _userContext$user_rol;
    var userId = userContext.object_id;
    var traits = {
      email: userContext.email || '',
      first_name: userContext.first_name || '',
      last_name: userContext.last_name || '',
      role: (_userContext$user_rol = userContext.user_role_account_weddings) === null || _userContext$user_rol === void 0 ? void 0 : _userContext$user_rol[0].role,
      name: userContext.first_name ? "".concat(userContext.first_name, " ").concat(userContext.last_name) : ''
    };
    if (!userId) throw new Error('Missig userId');else (0, _trackingHelper.trackIdentifyUser)(userId, traits);
    if (window.analytics && window.dataLayer) {
      window.dataLayer.push({
        event: 'User Identified',
        userId: userId,
        created_at: userContext.created_at
      });
    }
  }
}
function identifyGuestUser(_ref2) {
  var userContext = _ref2.userContext,
    hasGuestIdentified = _ref2.hasGuestIdentified,
    forceIdentify = _ref2.forceIdentify;
  if (userContext.is_guest && (!hasGuestIdentified || forceIdentify)) {
    var userId = userContext.object_id;
    var traits = {
      role: 'VISITOR'
    };
    if (!userId) throw new Error('Missig userId');else (0, _trackingHelper.trackIdentifyUser)(userId, traits);
  }
}
/**
 * Identify a user within Sailthru.
 * Result sets sailthru_hid with a SHA256 hash of the email
 * SEE: https://getstarted.sailthru.com/developers/api-client/javascript/#userSignUp
 * @param {string} email Users email
 * @returns {Promise<any>}
 */
function identifyUserSailthru(email, newUserData) {
  return new Promise(function (resolve) {
    // Ignore if Sailthru is not available
    if (typeof window.Sailthru === 'undefined') {
      resolve();
      return;
    }

    // In case something goes terribly wrong
    var forceResolveTimeout = window.setTimeout(resolve, 1000);
    var vars = {
      email: email
    };
    var newSailthruUserVarsFeature = window.zola && window.zola.feature && window.zola.feature.newSailthruUserVars;
    if (newUserData && newSailthruUserVarsFeature) {
      vars.first_account_created = newUserData.business_unit_source;

      // TODO: Sailthru tracking should probably be moved entirely to the BE.
      vars.first_component = newUserData.business_unit_feature;
      vars.first_account_device_type = (0, _detectBrowser.detectMobileDevice)() ? 'Mobile Web' : 'Desktop';
    }
    var sailthruRequest = {
      email: email,
      vars: vars,
      onSuccess: function onSuccess() {
        clearTimeout(forceResolveTimeout);
        resolve();
      },
      onError: function onError() {
        clearTimeout(forceResolveTimeout);
        resolve();
      }
    };
    try {
      window.Sailthru.integration('userSignUp', sailthruRequest);
    } catch (error) {
      resolve();
    }
  });
}
function fetchUserContext() {
  return _api.default.get('/website-nav/web-api/v1/user/get').then(function (json) {
    var isGuest = json.is_guest,
      email = json.email;
    if (isGuest) {
      (0, _storage.deleteCookie)('zolaLoggedIn');
    } else {
      (0, _storage.setCookie)('zolaLoggedIn', true);
    }
    // Temporarily set email for BounceX usage
    window.zola = window.zola || {};
    window.zola.tracking = {
      email: email || ''
    };
    return json;
  }).then(_logRocketUtils.mapUserContextToLogRocketIdentify).catch(function (err) {
    throw err;
  });
}
var createStoreAccount = exports.createStoreAccount = function createStoreAccount() {
  return function () {
    return _api.default.get('/website-nav/web-api/v1/user/create_store_account');
  };
};
function updateUserStatus() {
  return _api.default.get('/web-api/v1/user/status');
}
function requestPartnerStatus() {
  return {
    type: ActionType.REQUEST_PARTNER_STATUS
  };
}
function receivePartnerStatus(response) {
  return {
    type: ActionType.RECEIVE_PARTNER_STATUS,
    payload: response
  };
}
function getPartnerAccount() {
  return _api.default.get('/web-api/v1/account-invitation/list');
}
function invitePartner(request) {
  return _api.default.post('/web-api/v1/account-invitation/send', request);
}
var removeOrRevokePartner = exports.removeOrRevokePartner = function removeOrRevokePartner(uuid, removeOrRevoke) {
  return _api.default.post("/web-api/v1/account-invitation/uuid/".concat(uuid, "/").concat(removeOrRevoke));
};